import { render, staticRenderFns } from "./UsersParticipantsList.vue?vue&type=template&id=99b2209e&"
import script from "./UsersParticipantsList.vue?vue&type=script&lang=js&"
export * from "./UsersParticipantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports